import React from 'react'
import Layout from '../../Layout/Layout'

const Improving_Crop_Productivity = () => {
  return (
    <Layout>

        <div className='uk-container '>
           <div className='uk-grid'>
               <div className='uk-width-1-2'>
               <p  className='light uk-margin-xlarge-top'> The research focused on Improving Crop Productivity and Climate Resilience in
                 Nigeria by leveraging advanced Generative AI (GenAI) models for the agricultural sector.
                  These sophisticated models were specifically applied to perform high-resolution mapping 
                  and generate predictive analytics concerning farming conditions.</p>

      <p  className='light'>The application of these GenAI models demonstrated a strong and measurable potential
         to significantly impact national food security. Projections indicate the technology 
         could increase national crop yields by an estimated 25–40%. Crucially, the system also
          aids in simultaneously enhancing climate resilience by providing farmers with accurate 
          data on weather patterns, pest infestations, and optimal planting times.</p>


               </div>


                <div className='uk-width-1-2 '>
                  <p className='light uk-margin-xlarge-top'>This work directly contributes to the advancement of precision agriculture
                     within Nigeria, moving away from traditional, less-efficient farming methods
                      toward data-driven decision-making. By bolstering predictive capabilities
                       and operational efficiency, the research is vital for achieving national
                        food security goals and supporting crucial, context-specific climate 
                        adaptation strategies.</p>
                    
                    <p className='light'>Contribution: advancing precision agriculture, food security, and climate adaptation.</p>
                    <p className='light'>DOI: https://doi.org/10.5281/zenodo.16790294 </p>
               </div>
           </div>
        </div>

    </Layout>
  )
}

export default Improving_Crop_Productivity